import { createApp } from 'vue'; // Vue 3 import
import App from './App.vue';
import router from './router';
import Casdoor from 'casdoor-vue-sdk';
import { createPinia } from 'pinia'; // Import Pinia
import './assets/styles/global.css';
import { casdoorConfig } from './config';
import { createI18nInstance } from './plugins/i18n';
import { useLocaleStore } from './stores/localeStore';
// Vue.config.productionTip = false; // Not used in Vue 3 like this

/**
 * @typedef {object} CasdoorSDKConfig
 * @property {string} serverUrl - The URL of the Casdoor server (e.g., 'http://localhost:8000').
 * @property {string} clientId - The Client ID of your Casdoor application.
 * @property {string} organizationName - The name of the Casdoor organization.
 * @property {string} appName - The name of your Casdoor application.
 * @property {string} redirectPath - The path in your application where Casdoor redirects after authentication (e.g., '/callback').
 *                                  The full redirect URI will be this path appended to your application's base URL
 *                                  (e.g., 'http://localhost:8081/callback' if Vue app runs on 8081).
 */

/**
 * Configuration object for the Casdoor Vue SDK.
 * Replace placeholder values with your actual Casdoor application details.
 * @type {CasdoorSDKConfig}
 */

const app = createApp(App);

const pinia = createPinia(); // Create Pinia instance

app.use(router);
app.use(Casdoor, casdoorConfig);
app.use(pinia); // Use Pinia

const localeStore = useLocaleStore();
const initialLocale = localeStore.initializeLocale(); // Determine startup locale
const i18n = createI18nInstance(initialLocale);

const applyDocumentLanguage = (locale) => {
  if (typeof document === 'undefined') return;
  const htmlEl = document.documentElement;
  if (!htmlEl) return;
  const languageTag = locale === 'zh-CN' ? 'zh-CN' : 'en';
  htmlEl.setAttribute('lang', languageTag);
};

applyDocumentLanguage(initialLocale);

app.use(i18n);

localeStore.$subscribe((_mutation, state) => {
  if (i18n.global.locale.value !== state.currentLocale) {
    i18n.global.locale.value = state.currentLocale;
  }
  applyDocumentLanguage(state.currentLocale);
});

app.mount('#app');
